import { render, staticRenderFns } from "./LoginOTP.vue?vue&type=template&id=5c694787&scoped=true&"
import script from "./LoginOTP.vue?vue&type=script&lang=js&"
export * from "./LoginOTP.vue?vue&type=script&lang=js&"
import style0 from "./LoginOTP.vue?vue&type=style&index=0&id=5c694787&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c694787",
  null
  
)

export default component.exports